import { LockKey, ShieldCheck } from "@phosphor-icons/react";

export function SecurityBadge({ variant = "footer" }) {
  if (variant === "sidebar") {
    return (
      <div
        data-testid="security-badge-sidebar"
        className="flex items-center gap-1.5 mt-2 text-[9px] uppercase tracking-widest text-igc-success"
      >
        <LockKey size={11} weight="fill" />
        Secured
      </div>
    );
  }

  if (variant === "login") {
    return (
      <div
        data-testid="security-badge-login"
        className="flex items-center justify-center gap-2 mt-6 text-auth-muted"
      >
        <ShieldCheck size={16} weight="duotone" className="text-auth-success" />
        <span className="text-[11px] uppercase tracking-widest">
          256-bit SSL Secured &middot; Bank-Level Security
        </span>
      </div>
    );
  }

  return (
    <div
      data-testid="security-badge-footer"
      className="flex items-center justify-center gap-2 py-3 text-igc-muted border-t border-igc-gold/10"
    >
      <LockKey size={13} weight="fill" className="text-igc-success" />
      <span className="text-[10px] uppercase tracking-widest">
        256-bit SSL Secured &middot; Bank-Level Security
      </span>
    </div>
  );
}
